import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { multisportApi } from "../api/multisport";
import type { MultisportEntryPayload } from "../types";

const QK = ["multisport"] as const;

export function useMultisportEntries() {
  return useQuery({ queryKey: QK, queryFn: multisportApi.list });
}

export function useCreateMultisportEntry() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: MultisportEntryPayload) => multisportApi.create(payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useUpdateMultisportEntry() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: Partial<MultisportEntryPayload> }) =>
      multisportApi.update(id, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useDeleteMultisportEntry() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => multisportApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
